import { useMemo } from 'react'
import { useParams } from 'react-router-dom'
import { Card, CardBody, CardHeader } from 'reactstrap'
import { RouteParams } from '../../../../api/globalTypes'
import inDepthAnalysis from '../../../../api/inDepthAnalysis/hooks'
import { DataTableLayout, useDataTable, useTableState } from '../../../TanstackTable'
import { useTableColumns } from './useTableColumns'

const ContactsConnectedToCompany = () => {
    const { id } = useParams<RouteParams>()

    const tableState = useTableState()

    const { isLoading: fetchingAssociates, data: associateData } = inDepthAnalysis.GetCompanyAssociateById.useQuery(id, tableState.params)

    const columns = useTableColumns()

    const tableData = useMemo(() => associateData?.items ?? [], [associateData?.items])

    const { table } = useDataTable({
        ...tableState,
        columns,
        data: tableData,
        pageCount: associateData?.pagination?.totalPages ?? 0,
    })

    return (
        <Card>
            <CardHeader>
                <h5 className="mb-0 me-4">Kontakti povezani s poduzećem</h5>
            </CardHeader>
            <CardBody>
                <DataTableLayout
                    table={table}
                    isLoading={fetchingAssociates}
                    totalItems={associateData?.pagination?.totalItems}
                    theadClass="dmn-table-header"
                />
            </CardBody>
        </Card>
    )
}

export default ContactsConnectedToCompany
